import React from "react";

function CompanyAddressIcon({ fill = "#8C8594" }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			fill="none"
			viewBox="0 0 24 24"
		>
			<path
				fill={fill}
				fillRule="evenodd"
				d="M4.5 3.746c0-.412.334-.746.746-.746h13.508c.412 0 .746.334.746.746v17.18a.075.075 0 01-.075.074H4.575a.075.075 0 01-.075-.075V3.745zm9.375 12.19h-3.75V21h3.75v-5.063zM6.449 4.8a.074.074 0 00-.074.074v2.012c0 .04.033.074.074.074H8.56a.074.074 0 00.075-.074V4.874A.074.074 0 008.56 4.8H6.45zm4.426.074c0-.04.033-.074.074-.074h2.111c.041 0 .075.033.075.074v2.012a.074.074 0 01-.075.074h-2.11a.074.074 0 01-.075-.074V4.874zm4.574-.074a.074.074 0 00-.074.074v2.012c0 .04.033.074.074.074h2.111a.074.074 0 00.075-.074V4.874a.074.074 0 00-.075-.074h-2.11zM6.375 8.475c0-.041.033-.075.074-.075H8.56c.041 0 .075.034.075.075v2.011a.074.074 0 01-.075.074H6.45a.074.074 0 01-.075-.074V8.475zm4.574-.075a.074.074 0 00-.074.075v2.011c0 .041.033.074.074.074h2.111a.074.074 0 00.075-.074V8.475a.074.074 0 00-.075-.075h-2.11zm4.426.075c0-.041.033-.075.074-.075h2.111c.041 0 .075.034.075.075v2.011a.074.074 0 01-.075.074h-2.11a.074.074 0 01-.075-.074V8.475zM6.449 12a.074.074 0 00-.074.074v2.012c0 .04.033.074.074.074H8.56a.074.074 0 00.075-.074v-2.012A.074.074 0 008.56 12H6.45zm4.426.074c0-.04.033-.074.074-.074h2.111c.041 0 .075.033.075.074v2.012a.074.074 0 01-.075.074h-2.11a.074.074 0 01-.075-.074v-2.012zM15.449 12a.074.074 0 00-.074.074v2.012c0 .04.033.074.074.074h2.111a.074.074 0 00.075-.074v-2.012A.074.074 0 0017.56 12h-2.11z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

export default CompanyAddressIcon;
